import React, { useMemo, useState } from 'react';
import { ProductAnalyzerGroupContext, ProductAnalyzerGroupType } from './ProductAnalyzerGroupContext';
import { EditGroupMode, ProductAnalyzerGroupDetails } from '@models/Products';

const ProductAnalyzerGroupProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [selectedModelGroups, setSelectedModelGroups] = useState<string[]>([]);
  const [isCreateModalGroupPopUp, setIsCreateModalGroupPopUp] = useState<boolean>(false);
  const [groupNameToBeDelete, setGroupNameToBeDelete] = useState<string>('');
  const [isDeleteModalGroupPopUp, setIsDeleteModalGroupPopUp] = useState<boolean>(false);
  const [selectedModelsName, setSelectedModelsName] = useState<string[]>([]);
  const [isShareModalGroupPopUp, setIsShareModalGroupPopUp] = useState<boolean>(false);

  const groupDetails: ProductAnalyzerGroupDetails = {
    groupName: '',
    itemGroup: [],
    sortOrder: undefined,
  };

  const initialEditGroupMode: EditGroupMode = {
    groupDetails: groupDetails,
    isEditMode: false,
  };

  const [isEditGroupMode, setIsEditGroupMode] = useState<EditGroupMode>(initialEditGroupMode);

  const selectModelGroup = (models: string) => {
    if (isModelGroupSelected(models)) {
      setSelectedModelGroups(selectedModelGroups.filter((selectedModel) => selectedModel !== models));
    } else {
      setSelectedModelGroups([...selectedModelGroups, models]);
    }
  };

  const selectModelsName = (models: string) => {
    if (selectedModelsName.includes(models)) {
      setSelectedModelsName(selectedModelsName.filter((selectedModel) => selectedModel !== models));
    } else {
      setSelectedModelsName([...selectedModelsName, models]);
    }
  };

  const isModelGroupSelected = (models: string) => selectedModelGroups.includes(models);
  const clearSelectedModelsGroup = () => {
    setSelectedModelGroups([]);
    setSelectedModelsName([]);
  };

  const setIsCreateModalGroupShown = (value: boolean) => {
    setIsCreateModalGroupPopUp(value);
  };
  const selectGroupNameToBeDeleted = (groupName: string) => {
    setGroupNameToBeDelete(groupName);
  };

  const setIsDeleteModalGroupShown = (value: boolean) => {
    setIsDeleteModalGroupPopUp(value);
  };

  const setIsShareModalGroupShown = (value: boolean) => {
    setIsShareModalGroupPopUp(value);
  };

  const contextValue: ProductAnalyzerGroupType = useMemo(
    () => ({
      selectedModelGroups,
      selectedModelsName,
      selectModelGroup: selectModelGroup,
      selectModelsName: selectModelsName,
      clearSelectedModelsGroup: clearSelectedModelsGroup,
      isModelGroupSelected: isModelGroupSelected,
      isCreateModalGroupPopUp: isCreateModalGroupPopUp,
      setIsCreateModalGroupPopUp: setIsCreateModalGroupShown,
      groupNameToBeDelete: groupNameToBeDelete,
      setGroupNameToBeDelete: selectGroupNameToBeDeleted,
      isDeleteModalGroupPopUp: isDeleteModalGroupPopUp,
      setIsDeleteModalGroupPopUp: setIsDeleteModalGroupShown,
      isEditGroupMode: isEditGroupMode,
      setIsEditGroupMode: setIsEditGroupMode,
      isShareModalGroupPopUp: isShareModalGroupPopUp,
      setIsShareModalGroupPopUp: setIsShareModalGroupShown,
    }),
    [
      selectedModelGroups,
      selectedModelsName,
      selectModelGroup,
      selectModelsName,
      clearSelectedModelsGroup,
      isModelGroupSelected,
      isCreateModalGroupPopUp,
      setIsCreateModalGroupPopUp,
      groupNameToBeDelete,
      setGroupNameToBeDelete,
      isDeleteModalGroupPopUp,
      setIsDeleteModalGroupPopUp,
      isEditGroupMode,
      setIsEditGroupMode,
      isShareModalGroupPopUp,
      setIsShareModalGroupShown,
    ],
  );
  return <ProductAnalyzerGroupContext.Provider value={contextValue}>{children}</ProductAnalyzerGroupContext.Provider>;
};

export default ProductAnalyzerGroupProvider;
